import type { FC } from 'react';
import { Card, Image, Link, CardContent, Typography } from '@packages/shared';
import type { TopCategory } from '../../api/rest/types';

export type TopCategoryItemProps = {
  /** prop description for storybook args table */
  /** Top category item to render */
  categoryItem: TopCategory;
};

/**
 * TopCategoryItem Card displays an icon and a title for a given category item.
 * */
export const TopCategoryItem: FC<TopCategoryItemProps> = ({ categoryItem }) => (
  <Link href={categoryItem.urlPath} underline="none">
    <Card
      elevation={0}
      sx={{
        height: '100%',
        textAlign: 'center',
        paddingTop: 3.75,
        ':hover': {
          boxShadow: 2,
        },
        '.MuiCardContent-root': {
          px: 1,
          py: 2,
        },
      }}
    >
      <Image src={categoryItem.icon} alt={categoryItem.displayName} width={34} height={34} />
      <CardContent>
        <Typography variant="body2">{categoryItem.displayName}</Typography>
      </CardContent>
    </Card>
  </Link>
);
